import { dataLakeSerializer } from '@/providers/serializers/data-lake/data-lake';
import { http } from '../http';

export class DataLakeAPI {

    private static INSTANCE = new DataLakeAPI();

    static get instance() {
        return this.INSTANCE;
    }

    private namespace: string = 'api/datalake/v1';

    public fetchListOfTools(params: any) {
      const endpoint = `${this.namespace}/tools`;
      const headers = http.getTokenHeaders();
      return http.get(endpoint, headers, params).then((response) => {
            return dataLakeSerializer.normalizeToolData(response.data);
        });
    }

    public fetchActivitiesByStudent(params: any) {
        const endpoint = `${this.namespace}/student/report`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return dataLakeSerializer.normalizeStudentData(response.data);
        });
    }

    public fetchStudentsByActivity(params: any) {
        const endpoint = `${this.namespace}/activities/report`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers, params).then((response) => {
            return dataLakeSerializer.normalizeActivityData(response.data);
        });
    }


    // public fetchProvidersData() {
    //     const endpoint = `${this.namespace}/activities/report`;
    //     const headers = http.getTokenHeaders();
    //     return Promise.resolve(dataLakeSerializer.normalizeProviderData())
    // }

    public fetchCuriculumProvider(isHighContrastEnable: any) {
        const endpoint = `${window.location.origin}/stubs/curiculum-providers.json`;
        const headers = http.getTokenHeaders();
        return http.get(endpoint, headers).then((response) => {
            return dataLakeSerializer.normalizeCuriculumProvider(response.data , isHighContrastEnable);
        });
    }

    public fetchStudentsByVendor(params: any) {
        const endpoint = `${this.namespace}/tools/reports`;
        const headers = http.getTokenHeaders();
        return new Promise((resolve) => {
            return http.get(endpoint, headers, params).then((response) => {
                return resolve(dataLakeSerializer.normalizeStudentsVendor(response.data));
            });
        });
    }

}

export const dataLakeAPI = DataLakeAPI.instance;
